

























































































































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Pagination from '@/domain/pagination.entity';
import BillableItemsFilter from '@/domain/contract/entity/billable-items-filter.entity';
import ContractService from '@/domain/contract/service/contract.service';
import BillableItems from '@/domain/contract/entity/billable-items.entity';
import splitContent from '@/shared/directive/split-content';
import routeTo from '@/router/routeTo'
import FilterComponent from './billable-items-modal-filter.component.vue';
import Header from './header.json';

@Component({
  components: {
    MainButton,
    LabelSlot,
    FilterComponent,
    VbPagination,
    VbTooltipSlot,
  },
  filters: {
    splitContent,
  },
})
export default class BillableItemsModal extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    type: String,
    default: null,
  })
  incomingCompetence!: string;

  billableItems: BillableItems[] = [];

  header: any[] = Header;

  loading: boolean = false;

  refs: any = this.$refs;

  filter = BillableItemsFilter.of({});

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'contractversionId|asc',
  });

  applyFilter(filter: BillableItemsFilter) {
    this.filter = BillableItemsFilter.of(filter);
    this.getBillableItems();
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  closeModal() {
    this.modalState = false;
    this.refs.filter.clear();
  }

  goToContract(contractId: string): void {
    const route = {
      path: `/contract/${contractId}`,
    };
    routeTo(this.$router, route)
  }

  @Watch('showModal')
  getBillableItems() {
    if (this.showModal) {
      this.loading = true;
      ContractService.getBillableItems(this.businessUnitId, this.filter,
        this.pagination.page, this.pagination.itemsPerPage)
        .then((resp: any) => {
          this.billableItems = BillableItems.ofList(resp.content);
          this.pagination.total = resp.totalElements;
          this.pagination.pageCount = resp.totalPages;
        }).finally(() => {
          this.billableItems.forEach((item: BillableItems) => {
            item.competence = this.filter.competence;
          });
          this.loading = false;
        });
    }
  }

  updateTable() {
    this.pagination.verifyPage();
    this.getBillableItems();
  }

  created() {
    if (this.incomingCompetence) {
      this.filter.competence = this.incomingCompetence;
    }
    this.getBillableItems();
  }
}
